"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    deepClone: function() {
        return deepClone;
    },
    deepDeleteUndefined: function() {
        return deepDeleteUndefined;
    },
    deleteUndefined: function() {
        return deleteUndefined;
    },
    deleteUndefinedNullOrEmpty: function() {
        return deleteUndefinedNullOrEmpty;
    },
    deleteUndefinedOrNull: function() {
        return deleteUndefinedOrNull;
    },
    excludeFields: function() {
        return excludeFields;
    },
    isScalar: function() {
        return isScalar;
    },
    pickByPath: function() {
        return pickByPath;
    },
    pickFields: function() {
        return pickFields;
    }
});
const _json = require("./json");
const _objecttraverser = require("./object-traverser");
function deepClone(obj) {
    return (0, _json.parseJson)((0, _json.stringifyJson)(obj));
}
function deleteUndefined(obj) {
    if (!obj) return obj;
    Object.keys(obj).forEach((key)=>{
        if (obj[key] === undefined) {
            delete obj[key];
        }
    });
    return obj;
}
function deleteUndefinedOrNull(obj) {
    if (!obj) return undefined;
    Object.keys(obj).forEach((key)=>{
        if (obj[key] == null) {
            delete obj[key];
        }
    });
    return obj;
}
function deleteUndefinedNullOrEmpty(obj) {
    if (!obj) return undefined;
    Object.keys(obj).forEach((key)=>{
        const value = obj[key];
        // doing a loose null check to match null or undefined
        // then checking if there's a length prop and if its falsy (0)
        if (value == null || Object.hasOwn(value, 'length') && !value.length) {
            delete obj[key];
        }
    });
    return obj;
}
function deepDeleteUndefined(obj) {
    return (0, _objecttraverser.mapObject)(obj, (node)=>{
        if (node.value !== undefined) {
            node.setValue(node.value);
        }
    });
}
function excludeFields(item, keys) {
    if (!item || !(keys == null ? void 0 : keys.length)) return item;
    const fields = Object.entries(item).reduce((o, [k, v])=>{
        const key = k;
        if (!keys.includes(key)) {
            o[key] = v;
        }
        return o;
    }, {});
    return fields;
}
function pickFields(item, keys) {
    if (!item) return item;
    keys = keys != null ? keys : [];
    const fields = Object.entries(item).reduce((o, [k, v])=>{
        const key = k;
        if (keys.includes(key)) {
            o[key] = v;
        }
        return o;
    }, {});
    return fields;
}
function pickByPath(input, path) {
    const parts = path.split('.');
    let current = input;
    while(parts.length){
        const part = parts.shift();
        if (!part) break;
        if (isScalar(current)) return current;
        current = current[part];
        if (Array.isArray(current)) {
            const subPath = parts.join('.');
            return current.map((item)=>pickByPath(item, subPath));
        }
    }
    return current;
}
function isScalar(value) {
    if (value === null) return true;
    if (value instanceof Date) return true;
    const type = typeof value;
    switch(type){
        case 'string':
        case 'number':
        case 'boolean':
        case 'undefined':
        case 'bigint':
        case 'symbol':
            return true;
        default:
            return false;
    }
}

//# sourceMappingURL=object.js.map